import React from 'react';

export type AtlasDemoFamily = 'MNI' | 'PD25' | 'PD126';

// Presentation-only placeholders until the atlas catalog supplies these fields.
// These values must not influence asset selection or availability.
const demoTags = {
  MNI: { modalities: ['T1w', 'T2w', 'CT'], recommended: true },
  PD25: { modalities: ['T1w', 'T2w'], recommended: false },
  PD126: { modalities: ['T1w', 'T2w'], recommended: false },
} as const;

export default function AtlasDemoTags({ family }: { family: AtlasDemoFamily }) {
  const { modalities, recommended } = demoTags[family];

  return (
    <>
      <span
        className={`dicom-match-label pc-atlas-demo-recommendation ${recommended ? 'match-high' : 'match-uncertain'}`}
        title="Demo label — not a clinical recommendation"
      >
        {recommended ? 'Recommanded' : 'Unrecommanded'}
      </span>
      <span className="pc-atlas-modality-tags">
        {modalities.map(modality => (
          <span
            key={modality}
            className={`dicom-modality-badge modality-${modality.toLowerCase()}`}
            title="Demo modality label"
          >
            {modality}
          </span>
        ))}
      </span>
    </>
  );
}
